import React from 'react';
import { Alert, Button, Form, FormGroup, Row, Col } from 'reactstrap';
import config from '../../config';
import { TOKEN_KEY } from '../../constants';

class AddEditForm2 extends React.Component {
    state = {
        id: 0,
        REQUEST_ID: '',
        RESPONSE_ID: '',
        EXTENSION_1_FLAG: false,
        EXTENSION_2_FLAG: false,
        hideAlert1: true,
        hideAlert2: true,
        hideAlert3: true
    }

    onChecked = e => {
        this.setState({
            [e.target.name]: e.target.checked,
            hideAlert1: false
        })
        //console.log(e.target.checked)
    }

    onChecked2 = e => {
        this.setState({
            [e.target.name]: e.target.checked,
            hideAlert2: false
        })
        //console.log(e.target.checked)
    }

    submitFormEdit = e => {
        e.preventDefault()
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const submitUrl = config.api + '/response/' + this.state.RESPONSE_ID;
            req.open('POST', submitUrl);
            req.setRequestHeader('Content-Type', 'application/json');
            req.setRequestHeader("Authorization", sessionStorage.getItem(TOKEN_KEY));
            req.addEventListener('load', () => {
                if (req.status >= 200 && req.status < 300) {
                    // got this from the fetch polyfill, keeping it to be safe
                    const responseBody = 'response' in req ? req.response : req.responseText;
                    const results = JSON.parse(responseBody);
                    resolve(results);
                    //console.log(results);
                    this.props.toggle()
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else {
                    let error;
                    error = new Error(`server_error: ${req.statusText}`);
                    error.statusText = req.statusText;
                    reject(error);
                }
            });

            req.addEventListener('error', () => {
                const error = new Error('client_error: Network request failed');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert3: false
                })
            });

            req.addEventListener('abort', () => {
                const error = new Error('client_error: Request aborted');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert3: false
                })
            });

            req.addEventListener('timeout', () => {
                const error = new Error('client_error: Request timed out');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert3: false
                })
            });

            req.send(
                JSON.stringify({
                    EXTENSION_1_FLAG: this.state.EXTENSION_1_FLAG,
                    EXTENSION_2_FLAG: this.state.EXTENSION_2_FLAG,
                })
            );
        });
    }

    componentDidMount() {
        if (this.props.item) {
            const { id, REQUEST_ID, RESPONSE_ID, EXTENSION_1_FLAG, EXTENSION_2_FLAG } = this.props.item
            this.setState({ id, REQUEST_ID, RESPONSE_ID, EXTENSION_1_FLAG, EXTENSION_2_FLAG })
        }
    }

    render() {
        const style1 = this.state.hideAlert1 ? { display: 'none' } : {};
        const style2 = this.state.hideAlert2 ? { display: 'none' } : {};
        const style3 = this.state.hideAlert3 ? { display: 'none' } : {};

        return (
            <Form onSubmit={this.props.item ? this.submitFormEdit : this.submitFormAdd}>
                <Row>
                    <Col xs="12">
                        <Alert color="danger" style={style3}>
                            There is a problem. This request has not been processed. Please try submnitting again. If problem persists, please contact the Help Desk
                        </Alert>
                    </Col>
                    <Col xs="12">
                        <h3>Request ID {this.state.REQUEST_ID}</h3>
                    </Col>
                    <Col xs="12">
                        <Alert color="warning" style={style1}>
                            This Request is Scheduled to be Extended for 45 Days. Click SUBMIT to Confirm.
                            (Close this window to cancel changes)
                        </Alert>
                    </Col>
                    {(() => {
                        if (this.state.EXTENSION_1_FLAG === null) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <Alert color="warning" style={style1}>
                                                This Request is Scheduled to be Extended for 45 Days. Click SUBMIT to Confirm.
                                                (Close this window to cancel changes)
                                            </Alert>
                                            <input
                                                type="checkbox"
                                                name="EXTENSION_1_FLAG"
                                                id="EXTENSION_1_FLAG"
                                                onChange={this.onChecked}
                                                className="checkboxInput"
                                                value={this.state.EXTENSION_1_FLAG}
                                            />{' '}
                                            <label
                                                className="checkboxLabel"
                                                id="EXTENSION_1_FLAG"
                                                htmlFor="EXTENSION_1_FLAG"
                                            >
                                                Request Extension 1 - 45 Days (Enter extension reason in notes)
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                        else if (this.state.EXTENSION_1_FLAG === 1) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <input checked disabled
                                                type="checkbox"
                                                name="EXTENSION_1_FLAG"
                                                id="EXTENSION_1_FLAG"
                                                onChange={this.onChecked}
                                                className="checkboxInput disabled"
                                                value={this.state.EXTENSION_1_FLAG}
                                            />{' '}
                                            <label
                                                className="checkboxLabel disabled"
                                                id="EXTENSION_1_FLAG"
                                                htmlFor="EXTENSION_1_FLAG"
                                            >
                                                This request has been extended for 45 days
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                    })()}
                    <Col xs="12">
                        <Alert color="warning" style={style2}>
                            This Request is Scheduled to be Extended for an additional 45 Days. Click SUBMIT to Confirm
                            (Close this window to cancel changes)
                        </Alert>
                    </Col>
                    {(() => {
                        if (this.state.EXTENSION_2_FLAG === null) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <input
                                                type="checkbox"
                                                name="EXTENSION_2_FLAG"
                                                id="EXTENSION_2_FLAG"
                                                onChange={this.onChecked2}
                                                className="checkboxInput"
                                                value={this.state.EXTENSION_2_FLAG}
                                            />{' '}
                                            <label
                                                className="checkboxLabel"
                                                id="EXTENSION_2_FLAG"
                                                htmlFor="EXTENSION_2_FLAG"
                                            >
                                              Request Extension 2 - Additional 45 Days (Enter extension reason in notes)
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                        else if (this.state.EXTENSION_2_FLAG === 1) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <input checked disabled
                                                type="checkbox"
                                                name="EXTENSION_2_FLAG"
                                                id="EXTENSION_2_FLAG"
                                                onChange={this.onChecked}
                                                className="checkboxInput disabled"
                                                value={this.state.EXTENSION_2_FLAG}
                                            />{' '}
                                            <label
                                                className="checkboxLabel disabled"
                                                id="EXTENSION_2_FLAG"
                                                htmlFor="EXTENSION_2_FLAG"
                                            >
                                                This request has been extended for an additional 45 days
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                    })()}
                </Row>
                <Row>
                    <Col xs="12">
                        <Button color="primary" size="lg" block>Submit</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default AddEditForm2